<template>
  <GtcModal
    :open="props.open"
    :title="t('modals.common.verifyTips.title')"
    :loading="props.loading || props.pending"
    width="390px"
    :ok-text="t('modals.common.verifyTips.confirm')"
    :cancel-text="t('modals.common.verifyTips.cancel')"
    :closable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="flex items-center justify-center gap-5 mb-6">
      <img class="w-[72px]" src="@/assets/images/user/verify_tip.png" alt="verify" />
      <div class="flex flex-col gap-1">
        <div class="text-[16px] font-semibold text-ink-950">
          {{ t('modals.common.verifyTips.description') }}
        </div>
        <div class="text-[14px] text-ink-700">
          {{ t('modals.common.verifyTips.subDescription') }}
        </div>
      </div>
    </div>
  </GtcModal>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import GtcModal from '@/components/gtc-modal/GtcModal.vue'

const emit = defineEmits<{
  cancel: []
  confirm: []
}>()

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    open: boolean
    loading?: boolean
    pending?: boolean
  }>(),
  {
    loading: false,
    pending: false,
  },
)

const handleOk = () => {
  emit('confirm')
}

const handleCancel = () => {
  emit('cancel')
}
</script>
